import { useState } from "react";

// controllers
import { ProductController } from "controllers";

// helpers
import { addItem } from "../common/helper";

// components
import { Button } from "shared/components/bulma/button";
import { ProductSearchInput } from "shared/components/product";
import { Modal, ModalContent, ModalControl } from "shared/components/bulma/modal";

import Placeholder from "assets/placeholder-vertical.jpg";


const Item = ({ item }) => (
    <div key={item.id}>
        <div className="card-image">
            <figure className="image">
                <img src={item.imageURL} alt={item.barcode} />
            </figure>
        </div>
    </div>
);

const AddModal = ({ isActive, onDismiss, onConfirm }) => {
    const defaultNewItem = { imageURL: Placeholder };
    const [newItem, setNewItem] = useState(defaultNewItem);
    const [product, setProduct] = useState(null);

    const handleChange = async (event) => {
        const { value } = event.target;

        if (value) {
            const p = await ProductController.getProductByBarcode(value);
            const { barcode, imageURLs } = p;
            setNewItem({ barcode, imageURL: imageURLs[0] });
            setProduct(p);
        } else {
            setNewItem(defaultNewItem);
        }
    }

    const handleConfirm = () => {
        if (onConfirm) { onConfirm(product) };
    }

    const SubmitButton = () => {
        if (newItem.barcode) {
            return <Button onClick={handleConfirm} className="is-primary">Add</Button>
        }

        return null;
    }

    return (
        <Modal className="is-large" title="Add Item" isActive={isActive}>
            <ModalContent>

                <ProductSearchInput
                    placeholder="Type to search for an available product"
                    status="available" onChange={handleChange} />

                <Item item={newItem} />
            </ModalContent>
            <ModalControl>
                <SubmitButton />
                <Button onClick={onDismiss}>Cancel</Button>
            </ModalControl>
        </Modal>
    );
}

const AddItem = ({ customer, box, onAdd }) => {
    const [isActive, setActive] = useState(false);

    const handleClick = async () => {
        setActive(true);
    }

    const dismiss = () => {
        setActive(false);
    }

    const add = async (product) => {
        setActive(false);

        const newItem = await addItem(product, customer, box);
        if (onAdd) { onAdd(newItem); }
    }

    const Modal = () => {
        if (!isActive) {
            return null;
        }

        return (
            <AddModal isActive={isActive} onConfirm={add} onDismiss={dismiss} />
        );
    }

    return (
        <>
            <Button className="is-small is-dark is-outlined" onClick={handleClick} >
                <span className="icon">
                    <i className="fas fa-plus-square"></i>
                </span>
                <span>Add Item</span>
            </Button>

            <Modal />
        </>
    );
}

export { AddItem };
